module.exports = __webpack_public_path__ + "./img/share.e3c311c75a68173203b5cf55fea33020.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/share.png
// module id = ./assets/images/share.png
// module chunks = 0